/** Time the current assignment state was reached, taken from the operations feed. */
export function assignmentStatusAt(
  state?: string | null,
  startedAt?: string | null,
  completedAt?: string | null,
): string | null {
  if (state === 'Completed' || state === 'Failed' || state === 'Cancelled') {
    const completed = completedAt?.trim();
    return completed || null;
  }
  if (state === 'Running') {
    const started = startedAt?.trim();
    return started || null;
  }
  return null;
}
